module.exports = __webpack_public_path__ + "img/54c0d32.png";